import React from 'react';
import { useLocation } from 'react-router-dom';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Stack from '@mui/material/Stack';
import { Facebook, Instagram, YouTube } from '@mui/icons-material';
import { red, grey} from '@mui/material/colors';
import XIcon from '@mui/icons-material/X';
import { createTheme, IconButton, Tooltip, useMediaQuery } from '@mui/material';


import { NavItem } from './components';
import MenuSearchInput from '../../../../components/MenuSearchInput';
import ocpfLogo from '../../../../images//ocpfsmallicon.png';
import ocpfWatchLogo from '../../../../images/ocpf-watch-logo.jpg';

interface Props {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSidebarOpen: () => void;
  pages: {
    filers: Array<PageItem>;
    legal: Array<PageItem>;
    reports: Array<PageItem>;
    data: Array<PageItem>;
    forms: Array<PageItem>;
    clerk: Array<PageItem>;
    about: Array<PageItem>;
  };
  colorInvert?: boolean;
}

export const TopMenuTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 380,
      md: 900,
      lg: 1280,
      xl: 1536,
    },
  },
});

const Topbar = ({onSidebarOpen,pages,colorInvert = false,}: Props): JSX.Element => {
  
  const location = useLocation();
  const path = location.pathname || '';

  const theme = useTheme();

  const isLG = useMediaQuery(TopMenuTheme.breakpoints.up('lg'));
  const isXL = useMediaQuery(TopMenuTheme.breakpoints.up('xl'));
  const isMobileOK = useMediaQuery(TopMenuTheme.breakpoints.up('sm'));

  const {
    filers: filersPages,
    legal: legalPages,
    reports: reportsPages,
    data: dataPages,
    forms: formsPages,
    clerk: clerkPages,
    about: aboutPages,
  } = pages;


  const segments = path.split('/');
  const activeLink = segments.length >= 2 ? `${segments[0]}/${segments[1]}` : path;
  const lowerActiveLink = activeLink.toLowerCase();
  const isHomePage =
    lowerActiveLink === '/home1' ||
    lowerActiveLink === '/' ||
    lowerActiveLink === '/home' ||
    lowerActiveLink === '/index';
  

  const OcpfWatchButton = () => {
      return (
      <Button
        variant="outlined"
        color="success"
        href="https://www.ocpf.us/Home/Watch"
        component="a"
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          marginLeft: 1,
        }}
      >
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            overflow: 'hidden',
          }}
        >
          <img
            src={ocpfWatchLogo}
            alt="OCPF Watch Logo"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </Box>
      </Button>
    );
  }



  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      width={1}
    >
      <Box
        display={'flex'}
        component="a"
        href="/"
        title="OCPF"
        width={{ xs: 100, md: 120 }}
      >
        <Box
          component={'img'}
          alt="OCPF Logo"
          title="OCPF"
          aria-label='OCPF Logo'
          src={ocpfLogo}
          height={1}
          width={1}
        />
      </Box>
      {/* Desktop Navigation */}
      <Box sx={{ display: { xs: 'none', md: 'flex' } }} alignItems={'center'}>
        {/*
        <Box marginLeft={2.5}>
          <Link 
            underline="none" 
            component="a" 
            href="/FilerListing" 
            color={"/Filers" == activeLink || "/FilerListing" == activeLink ? 'primary' : 'text.primary'} 
            fontWeight={"/Filers" == activeLink || "/FilerListing" == activeLink? 700 : 400}
          >
            Filers
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Legal"
            color={"/Legal" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Legal" == activeLink ? 700 : 400}
          >
            Legal
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Reports"
            color={"/Reports" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Reports" == activeLink ? 700 : 400}
          >
            Reports
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Data"
            color={"/Data" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Data" == activeLink ? 700 : 400}
          >
            Data
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Publications"
            color={"/Publications" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Publications" == activeLink ? 700 : 400}
          >
            Forms
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <Link
            underline="none"
            component="a"
            href="/Municipal"
            color={"/Municipal" == activeLink ? 'primary' : 'text.primary'}
            fontWeight={"/Municipal" == activeLink ? 700 : 400}
          >
            Clerk
          </Link>
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'About'}
            id={'about-pages'}
            items={aboutPages}
            colorInvert={colorInvert}
          />
        </Box>
        */}
        
        <Box>
          <NavItem
            title={'Filers'}
            id={'filer-pages'}
            items={filersPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Legal'}
            id={'legal-pages'}
            items={legalPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Data'}
            id={'data-pages'}
            items={dataPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Reports'}
            id={'reports-pages'}
            items={reportsPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Forms'}
            id={'forms-pages'}
            items={formsPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'Clerks'}
            id={'clerk-pages'}
            items={clerkPages}
            colorInvert={colorInvert}
          />
        </Box>
        <Box marginLeft={2.5}>
          <NavItem
            title={'About'}
            id={'about-pages'}
            items={aboutPages}
            colorInvert={colorInvert}
          />
        </Box>

        {/* social media icons */}
        {
          ( (isHomePage && isLG) || lowerActiveLink.includes('search')) &&
          <Box marginLeft={3}>
            <Stack spacing={1} direction="row">
            <a aria-label='Youtube Icon' title='Youtube Icon' href="https://www.youtube.com/user/ocpfreports" target='_blank'>
              <YouTube sx={{ color: red[500] }} />
            </a>
            <a aria-label='Twitter Icon' title='Twitter Icon' href="https://twitter.com/OCPFReports" target='_blank'>
              <XIcon sx={{ color: grey[900] }}  />
            </a>
            <a aria-label='Instagram Icon' title='Instagram Icon' href="https://www.instagram.com/ocpfreports" target='_blank'>
              <Instagram sx={{ color: grey[800] }} />  
            </a>
            <a aria-label='Facebook Icon' title='Facebook Icon' href="https://www.facebook.com/massocpf/" target="_blank">
              <Facebook color="primary" />
            </a>
            {/*
              <a href="https://www.linkedin.com/company/ma-office-of-campaign-and-political-finance/" target='_blank'>
              <LinkedIn sx={{ color: blue[900] }} />  
            </a>
            */}
            </Stack>
          </Box>
        }
        {
          !isHomePage && !lowerActiveLink.includes('search') &&
          <Box marginLeft={3}>
            <MenuSearchInput></MenuSearchInput>
          </Box>
        }
        <Box marginLeft={2}>
          <Button
            variant="contained"
            color="primary"
            component="a"
            target="blank"
            size='small'
            href="https://www.ocpfreporter.us/Account/LogOn"
          >
            Sign In
          </Button>
        </Box>
        <Box marginLeft={1}>
          <Button
            variant="outlined"
            color="primary"
            component="a"
            target="blank"
            size='small'
            href="https://www.ocpfreporter.us/OnlineOrganization/SignUp"
          >
            Register
          </Button>
        </Box>
        {
          isHomePage && <Box marginLeft={1}>
            <Button
              variant="outlined"
              sx={{color: '#b45300', borderColor: '#b45300'}}
              component="a"
              target="blank"
              size='small'
              href="https://www.ncourt.com/x-press/X-onlinepayments.aspx?Juris=31c943a9-97cd-416f-bf50-8a0634242629"
            >
              {isXL ? "Pay Here" : "Pay"}
            </Button>
          </Box>
        }
        {/* {
          isHomePage &&
           <Tooltip title="Sign up for OCPF Watch notifications" arrow>
            <Box
              marginLeft={4}
              display={'flex'}
              alignItems={'end'}
              component="a"
              target="_blank"
              href="https://ocpfwatch.us/"
              width={{ xs: 80, md: 100 }}
             >
              <Box
                component={'img'}
                alt="Sign up for OCPF Watch notifications"
                aria-label='Sign up for OCPF Watch notifications'
                src={ocpfWatchLogo}
                height={0.9}
                width={0.9}
              />
            </Box>
          </Tooltip>
        } */}
      </Box>
       {/* Mobile Navigation */}
      <Box sx={{ display: { xs: 'flex', md: 'none' } }} alignItems={'left'}>
        <Stack direction={'row'} spacing={0.5} marginRight={1}>
            {!isHomePage && !lowerActiveLink.includes('search') &&
              <MenuSearchInput></MenuSearchInput>
            }
            <Button
              variant="outlined"
              size="small"
              color="primary"
              component="a"
              sx={{ paddingY: 0, paddingX: 0.4 }}
              href="https://www.ocpfreporter.us/">
              Sign In
            </Button>
            {
              isHomePage &&
              <Button
                variant="outlined"
                size="small"
                component="a"
                sx={{ paddingY: 0, paddingX: 0.4, color: '#b45300', borderColor: '#b45300'}}
                href="https://www.ncourt.com/x-press/X-onlinepayments.aspx?Juris=31c943a9-97cd-416f-bf50-8a0634242629">
                Pay Here
              </Button>
            }
        </Stack>
        {/* {
              isHomePage && isMobileOK &&
              <Tooltip title="Sign up for OCPF Watch alerts" arrow>
              <Box
                display={'flex'}
                alignItems={'end'}
                component="a"
                href="https://ocpfwatch.us/"
                target="_blank"
                width={80}
                marginLeft={1}
              >
                <Box
                  component={'img'}
                  alt="Sign up for OCPF Watch alerts"
                  aria-label='Sign up for OCPF Watch alerts'
                  src={ocpfWatchLogo}
                  height={0.9}
                  width={0.9}
                />
              </Box>
              </Tooltip>
            } */}
        <Button
          onClick={() => onSidebarOpen()}
          aria-label="Menu"
          variant={'outlined'}
          sx={{
            borderRadius: 2,
            minWidth: 'auto',
            padding: 1,
            borderColor: alpha(theme.palette.divider, 0.2),
          }}
        >
          <MenuIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default Topbar;
